// 表項目から一行削除画面
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@material-ui/core';

type DeleteTableAttributeRowDialogProps = {
  open: boolean;
  onClose: () => void;
  deleteTableRow: () => void;
}
const DeleteTableAttributeRowDialog: React.FC<DeleteTableAttributeRowDialogProps> = ({open, onClose, deleteTableRow}) => {
  const deleteExe = () => {
    deleteTableRow();
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="xs">
      <DialogTitle>選択された行を削除します</DialogTitle>
      <DialogContent>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text" color="primary">
          キャンセル
        </Button>
        <Button variant="text" color="primary" onClick={deleteExe}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteTableAttributeRowDialog;
